import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import {styles} from 'common/lib/styles';
import Dashboard from 'client/routes/Customer/Dashboard'
import Overview from 'client/routes/Customer/Overview'
import Energy from 'client/routes/Customer/Energy';
class Print extends Component {

    constructor (props) {
        super(props)
    }

    componentDidMount() {
        setTimeout(function (){
        window.print();
        }, 500);
    }

    render () {
        const { classes } = this.props
        return (
            <div className={classes.printRoot}>
                <div className={classes.printSection}><Dashboard {...this.props}/></div>
                <div className={classes.printSection}><Overview {...this.props}/></div>
                <div className={classes.printSection}><Energy {...this.props}/></div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(Print))